export type TamanhoCampoModal = "curto" | "medio" | "longo" | "total";

function comprimentoVisivel(valor: unknown): number {
  return String(valor ?? "")
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .length;
}

export function campoEstaPreenchido(valor: unknown): boolean {
  return comprimentoVisivel(valor) > 0;
}

export function inferirTamanhoCampoModal(
  valores: unknown[],
  tamanhoExplicito?: TamanhoCampoModal
): TamanhoCampoModal {
  if (tamanhoExplicito) return tamanhoExplicito;

  const maiorComprimento = valores.reduce<number>(
    (maior, valor) => Math.max(maior, comprimentoVisivel(valor)),
    0
  );

  if (maiorComprimento <= 12) return "curto";
  if (maiorComprimento <= 30) return "medio";
  return "longo";
}
